import i18n from 'i18next';

import forEach from 'lodash/forEach';

import { getDateString } from '@/exceed';

export default ({ isModalVariant, hasSelectedAllUsers = false, data }) => {
  const orderedContentList = {
    rootId: 'root',
    items: {
      root: {
        id: 'root',
        hasChildren: true,
        isExpanded: true,
        isChildrenLoading: false,
        data: { title: 'root' },
        children: [],
      },
    },
  };

  const createOrderedItem = ({ item }) => {
    orderedContentList.items.root.children.push(item.id);

    const user = isModalVariant ? item : item.user;

    const orderedItem = {
      id: item.id,
      isChildrenLoading: false,
      hasChildren: false,
      isExpanded: false,
      children: [],
      parentId: 'root',
      data: {
        ...user,
        formatted_enrolled_on: getDateString(item.enrolled_on),
        status: item.status,
        course_version_number:
          item.course_version_number === 0 ? i18n.t('draft') : item.course_version_number,
        due_on: item.due_on,
        recommended_by: item.recommended_by,
        relationship_type: item.relationship_type,
        relationship_reason: item.relationship_reason,
        completed_on: item.completed_on,
        expires_on: item.expires_on,
        score: item.score,
      },
    };

    orderedContentList.items[item.id] = orderedItem;

    return orderedItem.id;
  };

  forEach(data.data, (item) => createOrderedItem({ item }));

  return {
    enrollments: orderedContentList,
    meta: data.meta,
    pagination: data.pagination,
    hasSelectedAllUsers,
  };
};
